import { AsteriskIcon } from '@infinex/ui-icons';
import { cn } from '@infinex/ui-styles';

interface AsteriskNumberProps {
  /** The minimum number of digits to show */
  length?: number;
  /** Prefix to display before the hidden number */
  prefix?: string;
  /** Suffix to display after the hidden number */
  suffix?: string;
  /** Additional CSS classes */
  className?: string;
}

export function AsteriskNumber({
  length = 5,
  prefix = '',
  suffix = '',
  className,
}: AsteriskNumberProps) {
  return (
    <span className={cn('whitespace-nowrap tabular-nums', className)}>
      {prefix}
      {Array.from({
        length,
      }).map((_, index) => (
        <AsteriskIcon
          className="mx-px inline align-middle"
          style={{
            transform: 'translateY(-0.05em)',
            width: '1cap',
            height: '1cap',
          }}
          key={index}
        />
      ))}
      {suffix}
    </span>
  );
}
